<template>
    <div>
        <div class="i-layout-sider-logo" :class="{ 'i-layout-sider-logo-dark': siderTheme === 'dark' }">
            <transition name="fade-quick">
                <i-link to="/" v-show="!hideLogo">
                    <img src="@/assets/images/logo-small.png" v-if="menuCollapse">
                    <img src="@/assets/images/logo.png" v-else-if="siderTheme === 'light'">
                    <img src="@/assets/images/logo-dark.png" v-else>
                </i-link>
            </transition>
        </div>
        <div class="swiper-container" >
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <Menu ref="menu" class="i-layout-menu-side i-scrollbar-hide"
                        :class="{ 'i-layout-menu-side-collapse': menuCollapse }" :theme="siderTheme" :accordion="menuAccordion"
                        :active-name="activePath" :open-names="openNames" width="auto">
                        <template v-if="!menuCollapse && item.enable == 1" v-for="(item, index) in filterSider">
                            <i-menu-side-item @clickItem="clickItem" :menu="item" :key="index" />
                        </template>
                        <template v-else>
                            <Tooltip :content="tTitle(item.title)" placement="right"
                                v-if="item.children === undefined || !item.children.length" :key="index">
                                <i-menu-side-item :menu="item" hide-title />
                            </Tooltip>
                            <i-menu-side-collapse v-else :menu="item" :key="index" top-level />
                        </template>
                    </Menu>
                </div>
                <div class="swiper-slide">
                    <Menu ref="menu" class="i-layout-menu-side i-scrollbar-hide"
                        :class="{ 'i-layout-menu-side-collapse': menuCollapse }" :theme="siderTheme" :accordion="menuAccordion"
                        :active-name="activePath" :open-names="openNames" width="auto">
                        <template v-if="!menuCollapse && item.enable == 1" v-for="(item, index) in filterSider_item">
                            <i-menu-side-item @clickItem="clickItem(index,index === 0 ? 'back' : '')" :menu="item" :key="index" :type="index === 0 ? 'back' : null" />
                        </template>
                        <template v-else>
                            <Tooltip :content="tTitle(item.title)" placement="right"
                                v-if="item.children === undefined || !item.children.length" :key="index">
                                <i-menu-side-item :menu="item" hide-title />
                            </Tooltip>
                            <i-menu-side-collapse v-else :menu="item" :key="index" top-level />
                        </template>
                    </Menu>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import iMenuSideItem from './menu-item';
import iMenuSideSubmenu from './submenu';
import iMenuSideCollapse from './menu-collapse';
import tTitle from '../mixins/translate-title';
import { mapState, mapGetters } from 'vuex';
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
// 元素是否在可视区域
function isElementInViewport(el) {
    let rect = el.getBoundingClientRect();
    return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}

export default {
    name: 'iMenuSide',
    mixins: [tTitle],
    data() {
        return {
            swiper:null,
            filterSider_item:[],
            selectItem:{}
        }
    },
    components: { iMenuSideItem, iMenuSideSubmenu, iMenuSideCollapse },
    props: {
        hideLogo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('admin/layout', [
            'siderTheme',
            'menuAccordion',
            'menuCollapse'
        ]),
        ...mapState('admin/menu', [
            'activePath',
            'openNames'
        ]),
        ...mapGetters('admin/menu', [
            'filterSider'
        ])
    },
    watch: {
        '$route': {
            handler() {
                this.handleUpdateMenuState();
            },
            deep:true,
            immediate: true
        },
        // 在展开/收起侧边菜单栏时，更新一次 menu 的状态
        menuCollapse() {
            this.handleUpdateMenuState();
        },
        openNames(value, old) {
            this.$nextTick(() => {
                this.$refs.menu.updateOpened();
                this.$refs.menu.updateActiveName();
            })
        },
        '$store.state.admin.menu.activePath' (newValue, oldValue) {
            this.swiper.slidePrev()
            var filterSider = JSON.parse(JSON.stringify(this.$store.state.admin.menu.sider))
            this.updatemenu(newValue,filterSider)
            // var list = JSON.parse(JSON.stringify(this.filterSider_item)).map(val=>val.url)
            // console.log(newValue,list)
            // if(list.indexOf(newValue) !== -1){
            //     return
            // }else{
            //     this.swiper.slidePrev()
            //     var filterSider = JSON.parse(JSON.stringify(this.$store.state.admin.menu.sider))
            //     this.updatemenu(newValue,filterSider)
            // }

        },
        '$store.state.admin.menu.sider' (newValue, oldValue) {
            this.filterSider_item = []
            this.$nextTick(()=>{
                this.swiper.slidePrev()
            })
            this.updatemenu(this.$store.state.admin.menu.activePath,this.$store.state.admin.menu.sider)
        }
    },
    mounted() {
        this.swiper = new Swiper('.swiper-container', {
            direction: 'horizontal', // 垂直切换选项
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper
        })
    },
    methods: {
        updatemenu(value,filterSider){
                filterSider.forEach((val,index) => {
                    if(val.children){
                        val.children.forEach(item=>{
                            if(item.path === value){
                                this.filterSider_item = JSON.parse(JSON.stringify(val.children))
                                this.filterSider_item.unshift(val)
                                this.$nextTick(()=>{
                                    this.swiper.slideNext()
                                })
                            }
                        })
                    }
                })
        },
        clickItem(path,type) {
            if(type === 'back'){
                this.swiper.slidePrev()
            }else{
                
                var index  = this.filterSider.findIndex(val=>val.url === path)
                var flg = false
                for(var i in this.filterSider[index]){
                    if(i==="children"){
                        flg = true
                    }
                }
                if(!flg){
                    return
                }
                this.filterSider_item = JSON.parse(JSON.stringify(this.filterSider[index].children))
                this.filterSider_item.unshift(this.filterSider[index])
                this.$nextTick(()=>{
                    this.swiper.slideNext()
                })
            }
        },
        handleUpdateMenuState() {
            this.$nextTick(() => {
                if (this.$refs.menu) {
                    this.$refs.menu.updateActiveName();
                    if (this.menuAccordion) {
                        this.$refs.menu.updateOpened();
                    }

                    // 聚焦当前项
                    this.$nextTick(() => {
                        const $activeMenu = document.getElementsByClassName('ivu-menu-item ivu-menu-item-active ivu-menu-item-selected');
                        if ($activeMenu && $activeMenu.length && !isElementInViewport($activeMenu[0])) {
                            const activeMenuTop = $activeMenu[0].getBoundingClientRect().top;
                            const $menu = this.$refs.menu.$el;
                            setTimeout(() => {
                                this.$ScrollTop($menu, {
                                    to: activeMenuTop,
                                    time: 0
                                });
                            }, 300);
                        }
                    });
                }
            });
        }
    }
}
</script>
<style scoped></style>
